<div class="content nopad dark">
	<div class="row">
		<div class="col-lg-5">
			<div class="content dark">
				<google-map #googleMap *ngIf="bounds" width="100%" height="400px" [options]="mapOptions" (idle)="mapLoaded()">
					<map-marker *ngIf="path" [position]="path[path.length - 1]" [options]="stopMarkerOptions"></map-marker>
					<map-marker *ngIf="path" [position]="path[0]" [options]="startMarkerOptions"></map-marker>
					<map-marker *ngIf="mapInfoPosition" [position]="mapInfoPosition" [options]="markerOptions"></map-marker>
					<map-polyline *ngIf="path" [path]="path" [options]="polylineOptions"></map-polyline>
				</google-map>
			</div>
		</div>
		<div class="col-lg-7">
			<div class="content dark">
				<div *ngIf="operation && operation.e1_turb !== null" class="row mb-3">
					<div class="col-md-3">Engine 1 Cycles:</div>
					<div class="col-md-3">Turbine: {{ operation.e1_turb | number : "1.0-3" | ifempty : "No data" }}</div>
					<div class="col-md-3">Compressor: {{ operation.e1_comp | number : "1.0-3" | ifempty : "No data" }}</div>
					<div class="col-md-3">Impeller: {{ operation.e1_imp | number : "1.0-3" | ifempty : "No data" }}</div>
				</div>
				<div *ngIf="operation && operation.e2_turb !== null" class="row mb-3">
					<div class="col-md-3">Engine 2 Cycles:</div>
					<div class="col-md-3">Turbine: {{ operation.e2_turb | number : "1.0-3" | ifempty : "No data" }}</div>
					<div class="col-md-3">Compressor: {{ operation.e2_comp | number : "1.0-3" | ifempty : "No data" }}</div>
					<div class="col-md-3">Impeller: {{ operation.e2_imp | number : "1.0-3" | ifempty : "No data" }}</div>
				</div>
				<div *ngIf="operation && operation.distance !== null" class="row mb-3">
					<div class="col-lg-4">Distance: {{ operation.distance | number : "1.0-3" | ifempty : "No data" }}</div>
				</div>
				<div *ngIf="exceedances && exceedances.length">
					<div class="exceedance-list">
						<table>
							<tr>
								<th width="22px"></th>
								<th>Time</th>
								<th>Exceedance</th>
								<th>Description</th>
								<th>Duration</th>
							</tr>
							<tr *ngFor="let exceed of exceedances">
								<td>
									<div class="alert-light" [ngClass]="{ 'error': exceed.severity === 1, 'warning': exceed.severity !== 1 }"></div>
								</td>
								<td>{{exceed.timestamp | datetime : "time" : (fleet ? fleet.time_offset_hours : 0) }}</td>
								<td>{{exceed.name}}</td>
								<td>{{exceed.description}}</td>
								<td>{{exceed.duration | duration}}</td>
							</tr>
						</table>
					</div>
					<div class="form-group form-check mt-3">
						<label class="form-check-label">
							<input [(ngModel)]="ackChecked" [disabled]="this.api.user.role === 'readonly'" (ngModelChange)="UpdateAcknowledged()" class="form-check-input" type="checkbox">
							Acknowledge all exceedances for this operation
						</label>
					</div>
					<div *ngIf="ackUser">Acknowledged by {{ackUser}} on
						{{ackTime | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0)}}</div>
				</div>
				<div *ngIf="exceedances && !exceedances.length">
					No exceedances have been recorded for this operation
				</div>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-lg-12">
			<div class="content dark">
				<app-dvs-chart [error]="chartErrorMessage" [options]="chartOptions" [height]="'300px'" [timezone]="fleet ? fleet.time_offset_hours : 0"></app-dvs-chart>
				<div class="container">
					<div class="row">
						<ng-container *ngFor="let prop of graphParams">
							<div class="col-sm-4">
								<label>
									<input type="checkbox" [(ngModel)]="prop.selected" (ngModelChange)="refreshChart()">{{prop.name}}
								</label>
							</div>
						</ng-container>
					</div>
					<div class="row mt-4">
						<div class="col-sm-4 offset-sm-2 text-center">
							<button (click)="ClearSelections()" class="btn btn-info">Clear selections</button>
						</div>
						<div class="col-sm-4 text-center">
							<button (click)="ExportStates()" class="btn btn-info">Download State Data</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="components.enable_counts_gui" class="content dark mt-5">
		<app-expander caption="Counts over time">
			<div class="row">
				<div class="col-lg-4">
					<div class="content dark">If available, you may calculate total counts or distance over a date range</div>
				</div>
				<div class="col-lg-4">
					<div>
						Start
						<app-day-picker [(ngModel)]="startDate" (ngModelChange)="QueryCounts()"></app-day-picker>
					</div>
				</div>
				<div class="col-lg-4">
					<div>
						End
						<app-day-picker [(ngModel)]="endDate" (ngModelChange)="QueryCounts()"></app-day-picker>
					</div>
				</div>
			</div>
			<div *ngIf="countData" class="count-results">
				<div class="row mt-4">
					<div class="col-md-3"><b class="white">Engine 1 Cycles</b></div>
					<div class="col-md-3"><b>Turbine:</b> {{ countData.e1_turb | number : "1.0-3" | ifempty : "No data" }}</div>
					<div class="col-md-3"><b>Compressor:</b> {{ countData.e1_comp | number : "1.0-3" | ifempty : "No data" }}</div>
					<div class="col-md-3"><b>Impeller:</b> {{ countData.e1_imp | number : "1.0-3" | ifempty : "No data" }}</div>
				</div>
				<div *ngIf="countData.e2_turb !== null" class="row mt-4">
					<div class="col-md-3"><b class="white">Engine 2 Cycles</b></div>
					<div class="col-md-3"><b>Turbine:</b> {{ countData.e2_turb | number : "1.0-3" | ifempty : "No data" }}</div>
					<div class="col-md-3"><b>Compressor:</b> {{ countData.e2_comp | number : "1.0-3" | ifempty : "No data" }}</div>
					<div class="col-md-3"><b>Impeller:</b> {{ countData.e2_imp | number : "1.0-3" | ifempty : "No data" }}</div>
				</div>
				<div class="row mt-4">
					<div class="col-md-3"><b class="white">Total</b></div>
					<div class="col-md-3"><b>Distance:</b> {{ countData.distance | number : "1.0-3" | ifempty : "No data" : " km" }}</div>
					<div class="col-md-3"><b>Flight Time:</b> {{ countData.flight_time | runtime | ifempty : "No data" }}</div>
					<div class="col-md-3"><b>Rotor Turn Time:</b> {{ countData.rotor_turn_time | runtime | ifempty : "No data" }}</div>
				</div>
				<div class="row mt-4">
					<div class="col-md-12">
						{{countData.opcount}} active operations&nbsp;
						<span *ngIf="countData.opcount > 0">(<a (click)="DownloadActiveOperations()" href="javascript:void(0)" class="font-weight-bold">download CSV</a>)</span>
					</div>
				</div>
			</div>
		</app-expander>
	</div>
</div>